var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: { "task-list-pollers": true, loading: _vm.loading } },
    [
      _vm.pollers
        ? _c("table", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.formattedPollers, function(p) {
                return _c("tr", { key: p.identity }, [
                  _c("td", [_vm._v(_vm._s(p.identity))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(p.lastAccessTime))]),
                  _vm._v(" "),
                  _c("td", {
                    staticClass: "decision",
                    attrs: { "data-handled": p.handlesDecisions }
                  }),
                  _vm._v(" "),
                  _c("td", {
                    staticClass: "activity",
                    attrs: { "data-handled": p.handlesActivities }
                  })
                ])
              }),
              0
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", [_vm._v("Identity")]),
      _vm._v(" "),
      _c("th", [_vm._v("Last Access Time")]),
      _vm._v(" "),
      _c("th", [_vm._v("Decision Handler")]),
      _vm._v(" "),
      _c("th", [_vm._v("Activity Handler")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f3ab6bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f3ab6bf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/task-list/pollers.vue
// module id = 1744
// module chunks = 0